import {apiGet} from "@redriver/cinnamon";

const NAMESPACE = "BANNERS";

const ActionTypes = {
    getSystemInfo: `${NAMESPACE}/GET_SYSTEM_INFO`,
};

export const getSystemInfo = () => {
    return apiGet(
        ActionTypes.getSystemInfo,
        `system/info`
    );
};